// @ts-nocheck
import Vue from "vue";
import store from "../store/index.js";
import router from "../router";
import axios from "axios"; // ajax
import ElementUI from "element-ui"; // 样式组件
import "element-ui/lib/theme-chalk/index.css"; // 样式组件css
import "../fonts/iconfont.css";
import VueCodeMirror from "vue-codemirror";
import "codemirror/lib/codemirror.css";
import mavonEditor from "mavon-editor";
import "mavon-editor/dist/css/index.css";

import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import { RecycleScroller } from "vue-virtual-scroller";

Vue.component("RecycleScroller", RecycleScroller);

Vue.use(ElementUI);
Vue.use(VueCodeMirror);
Vue.use(mavonEditor);
Vue.prototype.$http = axios;

if (process.env.VUE_APP_INTRANET === "true") {
  store.state.Intranet = true;
}

// axios 配置
if (process.env.NODE_ENV === "development") {
  store.dispatch("setWsurl", process.env.VUE_APP_WSPROXY);
} else {
  store.dispatch("setWsurl", `ws://${location.host}`);
}
axios.defaults.withCredentials = true;
axios.defaults.timeout = 60 * 1000 * 3;

axios.interceptors.request.use(
  config => {
    if (config.url !== process.env.VUE_APP_NOTEBOOK) {
      config.headers["X-Requested-Type"] = store.state.requestHeader;
    }
    return config;
  },
  err => {
    Promise.reject(err);
  }
);

let showMessage = false;
axios.interceptors.response.use(
  res => {
    // 报错信息排除100
    if (res.data.code && res.data.code !== 200) {
      ElementUI.Message({
        type: "error",
        message: res.data.msg,
        duration: 1500
      });
      return Promise.reject(res);
    }
    return res;
  },
  err => {
    if (err.response) {
      switch (err.response.status) {
        case 401:
          router.replace("/login");
          store.dispatch("setUserInfo", null);
          localStorage.userInfo = "";
          break;
        default:
          if (showMessage) return;
          if (err.response.data.msg) {
            ElementUI.Message({
              type: "error",
              message: err.response.data.msg,
              duration: 1500
            });
          } else {
            ElementUI.Message({
              type: "error",
              message: "发生了未知的错误",
              duration: 1500
            });
          }
          setTimeout(() => {
            showMessage = false;
          }, 1700);
          break;
      }
    }

    return Promise.reject(err);
  }
);

router.beforeEach((to, from, next) => {
  // 未登录时，手动切换路由验证，跳转到登录页面
  if (!store.state.userInfo && to.name !== "login") {
    next("/login");
  }
  if (!store.state.MenuStatus && to.name !== "login") {
    getMenuConfig().then(({ newRouter }) => {
      store.dispatch("setMenu", newRouter);
      store.dispatch("setMenuState", true);
      if (to.name !== "home") {
        // 部分连接存在参数
        next(to.fullPath);
      } else {
        next({ name: rightName(newRouter) });
      }
    });
  } else if (to.matched.length && to.matched.every(r => r.meta.status)) {
    next();
  } else {
    // 没有权限的页面返回上一页或第一个权限页面
    next({ name: rightName(router.options.routes[1].children) });
  }
});
function rightName(newRouter) {
  let router = newRouter.find(r => r.meta.status);
  return router.children
    ? router.children.find(r => r.meta.status).name
    : router.name;
}
async function getMenuConfig() {
  try {
    let res = await Vue.prototype.$http
      .get("/gavial/v1/user/services")
      .catch(err => err);

    if (res.response && res.response.status === 401) {
      store.dispatch("setUserInfo", null);
      // localStorage.userInfo = "";
      localStorage.removeItem("userInfo");
      return Promise.reject(res);
    }
    let newRouter = router.options.routes[1].children;
    routerInit(newRouter);
    setRouter(newRouter, res.data.data);
    return {
      type: "success",
      newRouter
    };
  } catch (e) {
    return Promise.reject(e);
  }
}

function routerInit(router) {
  router.forEach(r1 => {
    if (r1.meta.serverConfigName) {
      r1.meta.status = false;
    }
    // filemanage
    if (r1.name === "filemanage") {
      r1.children.forEach(r2 => {
        r2.meta.status = false;
      });
    }
  });
}

function setRouter(routers = [], configs = []) {
  configs.forEach(config => {
    switch (config) {
      case "FILE":
      case "FILEMETA":
      case "BUCKET":
        setFilesystem(routers, config);
        break;

      default:
        routers.forEach(router => {
          if (router.meta && router.meta.serverConfigName === config) {
            router.meta.status = true;
          }
        });
        break;
    }
  });
}

function setFilesystem(routers = [], config = "") {
  const index = routers.findIndex(
    router => router.meta.serverConfigName === "FILESYSTOM"
  );
  if (index > -1) {
    routers[index].meta.status = true;
    routers[index].children.forEach((router, i) => {
      if (router.meta.serverConfigName === config) {
        routers[index].children[i].meta.status = true;
      }
    });
  }
}
